import React, { Component } from 'react';
import PropTypes, { string } from 'prop-types';
import styled from 'styled-components';

import TextInputTitle from './TextInputTitle';
// import { ToolTip } from './error';
import { Error } from './error/error';
import TextInputLimitCounter from './TextInputLimitCounter';

// import InfoTooltip from '../../../../libraries/utils/components/info-tooltip';

export const Wrapper = styled('div')`
  position: relative;
`;

export const Input = styled('input')`
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #d4d6d7;
  color: #363e44;
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 18px;
  outline: none;
  position: relative;
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease,
    color 0.2s ease, opacity 0.2s ease;
  vertical-align: middle;
  width: 100%;
  z-index: 1;
  padding: 12px 12px 12px 12px;

  margin-top: ${({ hasTitle }) => (hasTitle ? 'margin-top: 7px;' : '')};

  &:disabled {
    color: #a8abae;
    border: 1px solid #eaebeb;
  }
`;

const CounterContainer = styled.div`
  position: absolute;
  z-index: 9;
  top: 50%;
  right: 6px;
  transform: translateY(-50%);
`;

const ErrorMessage = styled.div`
  font-size: 13px;
  color: red;
  margin-top: 6px;
`;

/**
 * @description This is the default validatior.
 * Valid if not empty
 * @param {string} str
 * @returns {boolean} return true if the input is valid
 */
export const requiredValidatior = str => {
  if (typeof str !== 'string') {
    return false;
  }

  if (str === '') {
    return false;
  }
  return true;
};

export default class TextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didBlur: false
    };
  }

  handleBlur(evt, callback = () => {}) {
    this.setState({ didBlur: true }, callback);
  }

  isValid() {
    const { value, validatior } = this.props;
    this.handleBlur(null, this.forceUpdate);
    return validatior(value);
  }

  onChange(event) {
    this.props.onChange(event.target.value);
  }

  shouldShowError() {
    const { title, value, validatior } = this.props;
    const { didBlur } = this.state;

    const worngValueCondition = !validatior(value);
    const titleCondition = typeof title === 'string';

    if (worngValueCondition && titleCondition && didBlur) {
      return true;
    }

    return false;
  }

  render() {
    const {
      maxLength,
      disabled,
      title,
      value,
      validationMessage,
      hideTitle,
      error: hasError,
      placeholder,
      withCircleError
    } = this.props;

    let error = null;
    let style = {};
    if (this.shouldShowError() === true) {
      error = withCircleError ? (
        <Error message={validationMessage} />
      ) : (
        <ErrorMessage>{validationMessage}</ErrorMessage>
      );
      style = {
        border: '1px solid rgba(219,55,55,0.50)'
      };
    }
    if (hasError) {
      style = {
        border: '1px solid rgba(219,55,55,0.50)'
      };
    }

    return (
      <Wrapper>
        {!!hideTitle && (
          <CounterContainer>
            <TextInputLimitCounter
              maxLength={maxLength}
              currentLength={(value && value.length) || 0}
            />
          </CounterContainer>
        )}
        {!hideTitle && (
          <TextInputTitle
            hideTitle={hideTitle}
            maxLength={maxLength}
            currentLength={(value && value.length) || 0}
          >
            {title}
          </TextInputTitle>
        )}
        <Input
          placeholder={placeholder}
          className={`text-input ${this.props.isDefaultValue ? 'is-default-value' : ''} ${
            this.props.className ? this.props.className : ''
          }`}
          value={value}
          onChange={this.onChange.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          style={style}
          disabled={disabled}
          maxLength={'' + maxLength}
        />
        {error}
      </Wrapper>
    );
  }
}

TextInput.defaultProps = {
  title: '',
  validatior: () => {},
  onChange: () => {},
  validationMessage: '',
  disabled: false,
  wrapperStyle: {},
  placeholder: '',
  withCircleError: true
};

TextInput.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  value: PropTypes.string,
  onChange: PropTypes.func,
  /**
   * Validatior should return true if the input is valid
   */
  validatior: PropTypes.func,
  validationMessage: PropTypes.string,
  disabled: PropTypes.bool,
  wrapperStyle: PropTypes.object,
  maxLength: PropTypes.number,
  error: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  withCircleError: PropTypes.bool
};
